import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyDefaultPageSeo, applyPageSeo, PageSeoInput } from '../seo/pageSeo';

export function usePageSeo(input: PageSeoInput) {
  const location = useLocation();
  const path = input.path ?? location.pathname;
  const jsonLdKey = input.jsonLd ? JSON.stringify(input.jsonLd) : '';

  useEffect(() => {
    applyPageSeo({ ...input, path });
  }, [
    input.title,
    input.description,
    input.ogImage,
    input.locale,
    input.noindex,
    jsonLdKey,
    path,
  ]);
}

export function useDefaultPageSeo(options?: { noindex?: boolean; locale?: 'de_DE' | 'en_US' }) {
  useEffect(() => {
    applyDefaultPageSeo(options);
  }, [options?.noindex, options?.locale]);
}
